

































































































import { Mixins, Component, Prop, Ref } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import { generalSettings, catalogueSettings } from "@/models/Setting";
import { camelToUnderscore } from "../utils/Typography";
import { configuratorSettings, SettingEntry } from "../models/Setting";
import UploadCatalogue from "@/components/CatalogueSettings/Upload.vue";
import DownloadCatalogue from "@/components/CatalogueSettings/Download.vue";
import CatalogueSettingsMixin from "@/mixins/http/CatalogueSettingsMixin";
import { showToast } from "@/utils/RailsRoutes";
import { RegisterHttp } from "@/utils/Decorators";
import RequestData from "@/store/types/RequestData";

const UPLOAD_CATALOGUE_TAG = "upload_catalogue_tag";

@Component({ components: { Page, UploadCatalogue, DownloadCatalogue } })
export default class Settings extends Mixins(CatalogueSettingsMixin) {
  @Ref("uploadModal") readonly updateModal!: UploadCatalogue;
  @Ref("downloadModal") readonly downloadModal!: UploadCatalogue;
  @RegisterHttp(UPLOAD_CATALOGUE_TAG) readonly uploadRequestData!: RequestData;
  showProgress = false;

  get general() {
    return generalSettings;
  }

  get catalogue() {
    return catalogueSettings;
  }

  get configurator() {
    return configuratorSettings;
  }

  get loading() {
    return this.uploadRequestData?.loading;
  }

  onUploadCatalogue() {
    this.updateModal.show();
  }

  onGeneralSettingClicked(param: SettingEntry) {
    this.$router.push({
      name: "general_setting",
      params: { section: camelToUnderscore(param.type) },
    });
  }
  onCatalogueSettingClicked(param: SettingEntry) {
    this.$router.push({
      name: "catalogue_setting",
      params: { section: camelToUnderscore(param.type) },
    });
  }
  onConfiguratorSettingClicked(param: SettingEntry) {
    this.$router.push({
      name: "blueprints",
      params: { section: camelToUnderscore(param.type) },
    });
  }

  async onUploadRequest(data: FormData) {
    this.showProgress = true;
    const resp = await this.uploadCatalogue(data, UPLOAD_CATALOGUE_TAG);
    const status = this.uploadRequestData;

    if (this.uploadRequestData.statusCode === 200) {
      showToast("Models correctly imported");
    }
  }
  async onDownloadloadCatalogue() {
    this.showProgress = true;
    this.downloadModal.show();
  }
}
